import { SOURCES } from '../constants/sources';

export const parseHomeworkId = (homeworkId, idCat, source) => {
    if (source === SOURCES.TT) {
        return idCat ?? homeworkId;
    }

    if (!homeworkId) {
        return null;
    }

    return homeworkId.split('_').length === 3 ? homeworkId.split('_')[2] : homeworkId;
};
